// extracted by mini-css-extract-plugin
export default {"interest":"InterestsSection_interest__xqu9W","interest_content":"InterestsSection_interest_content__OKSzY"};